import { createStore } from 'vuex';
import CurrencyRates from '@/CurrencyRates.js';
import LanguageSetting from '@/LanguageSetting.js';

export default createStore({
  state: {
    //SHOP INFO SETTINGS
    shopName: process.env.VUE_APP_SHOP_NAME || 'NA',
    shopID: process.env.VUE_APP_SHOP_ID || 'NA',
    VUE_APP_SHOP_FULLNAME: '',
    VUE_APP_SHOP_SHORTNAME: '',
    VUE_APP_SHOP_WHATSAPP: '',
    VUE_APP_SHOP_WECHAT: '',
    VUE_APP_SHOP_PHONE: '',
    VUE_APP_SHOP_IG: '',
    VUE_APP_SHOP_FB: '',
    VUE_APP_SHOP_EMAIL: '',
    VUE_APP_SHOP_ADDRESS: '',
    VUE_APP_SOCIAL_INTRO: '',
    VUE_APP_SHOP_HOMEPAGE_INTRO: '',
    VUE_APP_SHOP_LOGO: '',
    VUE_APP_SOCIAL_PREVIEW_IMAGE: '',    

    //PAYMENT SETTINGS
    VUE_APP_CreditCard: '',
    VUE_APP_ALIPAY: '',
    VUE_APP_MPAYPERSONAL: '',
    VUE_APP_MPAY_QR: '',
    VUE_APP_BOCPERSONAL: '',
    VUE_APP_BOC_QR: '',
    VUE_APP_FPSnMPay: '',
    VUE_APP_AUTO_MPAY: '',
    VUE_APP_FPS_ACCOUNT: '',
    VUE_APP_DISPLAY_PAYCHANNEL: '',
    VUE_APP_USD: '',
    VUE_APP_EUR: '',
    VUE_APP_HKD: '',
    VUE_APP_MOP: '',


    //DELIVERY SETTINGS
    VUE_APP_EBUY_ENABLE: '',
    VUE_APP_HOME_DELIVERY_ENABLE: '',
    VUE_APP_HOME_FREE_DELIVERY_ENABLE: '',
    VUE_APP_OVERSEA_DELIVERY_ENABLE: '',
    VUE_APP_PICKUP_ENABLE: '',
    VUE_APP_MASTER_DELIVERY_ENABLE: '',
    VUE_APP_CART_FREE_DELIVERY_LIMIT_MOP: '',
    VUE_APP_CART_DELIVERY_FEE_MOP: '',
    VUE_APP_CART_FREE_DELIVERY_LIMIT_HKD: '',
    VUE_APP_CART_DELIVERY_FEE_HKD: '',
    VUE_APP_CART_FREE_DELIVERY_LIMIT_USD: '',
    VUE_APP_CART_DELIVERY_FEE_USD:  '',    
    VUE_APP_CART_FREE_DELIVERY_LIMIT_EUR: '',
    VUE_APP_CART_DELIVERY_FEE_EUR:  '', 

    //OTHER SETTINGS
    VUE_APP_SHOW_INVENTORY:  '', 
    VUE_APP_GA4:  '', 
    VUE_APP_WHATSAPPCHAT_HOMEPAGE_ENABLE:  '', 
    VUE_APP_WHATSAPPCHAT_PRODUCTPAGE_ENABLE:  '', 
    VUE_APP_WHATSAPPCHAT_PROMOTIONPAGE_ENABLE: '',
    VUE_APP_WHATSAPPCHAT_NO:  '', 
    VUE_APP_HOMEPAGE_LAYOUT:  '', 
    VUE_APP_HOMEPAGE_PRODUCT_TITLE:  '', 
    VUE_APP_CART_BTN:  '', 
    VUE_APP_CART_LIST:  '', 
    VUE_APP_CART_LIST_PAID:  '', 
    VUE_APP_ENG:  '', 
    VUE_APP_CN:  '', 
    VUE_APP_DEFAULT_LANGUAGE:  null, 
    VUE_APP_CART_COUNTRYCODE_DISPLAY:  '', 


    selectedCurrency: '',
    rate: '',
    rateCountry: '',
    selectedLanguage: '',
    lastVisit: "",


  },
  mutations: {
    changeCurrency(state, myCurrency) {
      state.selectedCurrency = myCurrency;
      state.rate = CurrencyRates[myCurrency].rate;
      state.rateCountry = CurrencyRates[myCurrency].rateCountry;
    },

    changeLanguage(state, newLanguage) {
      state.selectedLanguage = newLanguage;
    },


    setShopInfoSettings(state, settings) {
      state.VUE_APP_SHOP_FULLNAME = settings.VUE_APP_SHOP_FULLNAME || '';
      state.VUE_APP_SHOP_SHORTNAME = settings.VUE_APP_SHOP_SHORTNAME || '';
      state.VUE_APP_SHOP_WHATSAPP = settings.VUE_APP_SHOP_WHATSAPP || '';
      state.VUE_APP_SHOP_WECHAT = settings.VUE_APP_SHOP_WECHAT || '';
      state.VUE_APP_SHOP_PHONE = settings.VUE_APP_SHOP_PHONE || '';
      state.VUE_APP_SHOP_IG = settings.VUE_APP_SHOP_IG || '';
      state.VUE_APP_SHOP_FB = settings.VUE_APP_SHOP_FB || '';
      state.VUE_APP_SHOP_EMAIL = settings.VUE_APP_SHOP_EMAIL || '';
      state.VUE_APP_SHOP_ADDRESS = settings.VUE_APP_SHOP_ADDRESS || '';
      state.VUE_APP_SOCIAL_INTRO = settings.VUE_APP_SOCIAL_INTRO || '';
      state.VUE_APP_SHOP_HOMEPAGE_INTRO = settings.VUE_APP_SHOP_HOMEPAGE_INTRO || '';
      state.VUE_APP_SHOP_LOGO = settings.VUE_APP_SHOP_LOGO || '';
      state.VUE_APP_SOCIAL_PREVIEW_IMAGE = settings.VUE_APP_SOCIAL_PREVIEW_IMAGE || '';
    },

    setPaymentSettings(state, settings) {
      state.VUE_APP_CreditCard = settings.VUE_APP_CreditCard || '';
      state.VUE_APP_ALIPAY = settings.VUE_APP_ALIPAY || '';
      state.VUE_APP_MPAYPERSONAL = settings.VUE_APP_MPAYPERSONAL || '';
      state.VUE_APP_MPAY_QR = settings.VUE_APP_MPAY_QR || '';
      state.VUE_APP_BOCPERSONAL = settings.VUE_APP_BOCPERSONAL || '';
      state.VUE_APP_BOC_QR = settings.VUE_APP_BOC_QR || '';
      state.VUE_APP_FPSnMPay = settings.VUE_APP_FPSnMPay || '';
      state.VUE_APP_AUTO_MPAY = settings.VUE_APP_AUTO_MPAY || '';
      state.VUE_APP_FPS_ACCOUNT = settings.VUE_APP_FPS_ACCOUNT || '';
      state.VUE_APP_DISPLAY_PAYCHANNEL = settings.VUE_APP_DISPLAY_PAYCHANNEL || '';      
      state.VUE_APP_USD = settings.VUE_APP_USD || '';
      state.VUE_APP_EUR = settings.VUE_APP_EUR || '';
      state.VUE_APP_HKD = settings.VUE_APP_HKD || '';
      state.VUE_APP_MOP = settings.VUE_APP_MOP || '';
    },

    setDeliverySettings(state, settings) {
      state.VUE_APP_EBUY_ENABLE = settings.VUE_APP_EBUY_ENABLE || '';
      state.VUE_APP_HOME_DELIVERY_ENABLE = settings.VUE_APP_HOME_DELIVERY_ENABLE || '';
      state.VUE_APP_HOME_FREE_DELIVERY_ENABLE = settings.VUE_APP_HOME_FREE_DELIVERY_ENABLE || '';
      state.VUE_APP_OVERSEA_DELIVERY_ENABLE = settings.VUE_APP_OVERSEA_DELIVERY_ENABLE || '';
      state.VUE_APP_PICKUP_ENABLE = settings.VUE_APP_PICKUP_ENABLE || '';
      state.VUE_APP_MASTER_DELIVERY_ENABLE = settings.VUE_APP_MASTER_DELIVERY_ENABLE || '';
      state.VUE_APP_CART_FREE_DELIVERY_LIMIT_MOP = settings.VUE_APP_CART_FREE_DELIVERY_LIMIT_MOP || '';
      state.VUE_APP_CART_DELIVERY_FEE_MOP = settings.VUE_APP_CART_DELIVERY_FEE_MOP || '';
      state.VUE_APP_CART_FREE_DELIVERY_LIMIT_HKD = settings.VUE_APP_CART_FREE_DELIVERY_LIMIT_HKD || '';
      state.VUE_APP_CART_DELIVERY_FEE_HKD = settings.VUE_APP_CART_DELIVERY_FEE_HKD || '';
      state.VUE_APP_CART_FREE_DELIVERY_LIMIT_USD = settings.VUE_APP_CART_FREE_DELIVERY_LIMIT_USD || '';
      state.VUE_APP_CART_DELIVERY_FEE_USD = settings.VUE_APP_CART_DELIVERY_FEE_USD || '';
      state.VUE_APP_CART_FREE_DELIVERY_LIMIT_EUR = settings.VUE_APP_CART_FREE_DELIVERY_LIMIT_EUR || '';
      state.VUE_APP_CART_DELIVERY_FEE_EUR = settings.VUE_APP_CART_DELIVERY_FEE_EUR || '';
    },

    setShopOtherSettings(state, settings) {
      state.VUE_APP_SHOW_INVENTORY = settings.VUE_APP_SHOW_INVENTORY || '';
      state.VUE_APP_WHATSAPPCHAT_HOMEPAGE_ENABLE = settings.VUE_APP_WHATSAPPCHAT_HOMEPAGE_ENABLE || '';
      state.VUE_APP_WHATSAPPCHAT_PRODUCTPAGE_ENABLE = settings.VUE_APP_WHATSAPPCHAT_PRODUCTPAGE_ENABLE || '';
      state.VUE_APP_WHATSAPPCHAT_PROMOTIONPAGE_ENABLE = settings.VUE_APP_WHATSAPPCHAT_PROMOTIONPAGE_ENABLE || '';
      state.VUE_APP_WHATSAPPCHAT_NO = settings.VUE_APP_WHATSAPPCHAT_NO || '';
      state.VUE_APP_HOMEPAGE_LAYOUT = settings.VUE_APP_HOMEPAGE_LAYOUT || '';
      state.VUE_APP_HOMEPAGE_PRODUCT_TITLE = settings.VUE_APP_HOMEPAGE_PRODUCT_TITLE || '';
      state.VUE_APP_CART_BTN = settings.VUE_APP_CART_BTN || '';
      state.VUE_APP_CART_LIST = settings.VUE_APP_CART_LIST || '';
      state.VUE_APP_CART_LIST_PAID = settings.VUE_APP_CART_LIST_PAID || '';
      state.VUE_APP_ENG = settings.VUE_APP_ENG || '';
      state.VUE_APP_CN = settings.VUE_APP_CN || '';
      state.VUE_APP_DEFAULT_LANGUAGE = settings.VUE_APP_DEFAULT_LANGUAGE || '';
      state.VUE_APP_CART_COUNTRYCODE_DISPLAY = settings.VUE_APP_CART_COUNTRYCODE_DISPLAY || '';
    }
  },
  
  getters: {
    translate: (state) => (key) => {
      return state.selectedLanguage === 'CN' ? key : (LanguageSetting[state.selectedLanguage][key] || key);
    }
  }
});

